import React, { Suspense, useRef, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import PathPickSearchProductsHeader from "./components/PathPickSearchProductsHeader";
import PathPickSearchProductsProductListSection from "@/features/pathpick/features/search-products/components/product-list";
import PathPickSearchProductsPopularSection from "@/features/pathpick/features/search-products/components/popular";
import CenteredSpinner from "@/shared/components/centered-spinner";
import PathPickMembershipExpiredPanel from "@/features/pathpick/components/PathPickMembershipExpiredPanel";
import useMembership from "@/shared/hooks/useMembership";
import { PathPickHotDealLineSheet } from "@/features/pathpick/types";
import PathPickBadge from "@/features/pathpick/components/ui/PathPickBadge";
import { Helmet } from "react-helmet-async";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

function PathPickSearchProductsPage() {
  const { tTitle } = useI18nHelper();
  const pageTitle = `${tTitle("common:navigation.path_pick")} | ${tTitle(
    "common:navigation.path_pick_search_products"
  )}`;
  const { expiredStatus } = useMembership();
  // 이 Box가 이 화면의 유일한 스크롤 주체다(body는 스크롤되지 않는다).
  // 목록 하단의 "맨 위로" 버튼이 직접 스크롤을 조작해야 해서 ref를 내려보낸다.
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  // 인기 섹션(핫딜 라인시트)과 상품 리스트 섹션이 함께 쓰는 선택 상태
  const [selectedLineSheet, setSelectedLineSheet] =
    useState<PathPickHotDealLineSheet | null>(null);

  return (
    <Box
      ref={scrollContainerRef}
      sx={{
        padding: "16px",
        overflow: "auto",
        height: "100%",
        // 하단 패딩을 두면 목록 페이지네이션의 sticky bottom 기준선이 그만큼 올라가
        // 바가 화면 바닥에서 뜬다. 카드 바닥과 화면 바닥을 일치시켜 붙여 둔다.
        paddingBottom: 0,
      }}
    >
      <Helmet>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} />
      </Helmet>
      <Flex flexDirection={"column"} gap={"16px"} height={"100%"}>
        {/* 체험·멤버십 만료 시 헤더만 남기고 본문을 잠금 안내로 대체한다(시안). */}
        {expiredStatus ? (
          <>
            <PathPickSearchProductsHeader />
            <PathPickMembershipExpiredPanel status={expiredStatus} />
          </>
        ) : (
          <Suspense fallback={<CenteredSpinner />}>
            <PathPickSearchProductsHeader />
            <PathPickSearchProductsPopularSection
              selectedLineSheetId={selectedLineSheet?.id ?? null}
              onSelectLineSheet={setSelectedLineSheet}
            />
            <PathPickSearchProductsProductListSection
              selectedLineSheet={selectedLineSheet}
              onClearSelectedLineSheet={() => setSelectedLineSheet(null)}
              scrollContainerRef={scrollContainerRef}
            />
          </Suspense>
        )}
      </Flex>
    </Box>
  );
}

export default PathPickSearchProductsPage;
